import React, { useState, useEffect } from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import image1 from "../images/Carrusel1.webp";
import image2 from "../images/Carrusel2.webp";
import image3 from "../images/Carrusel3.webp";
import image4 from "../images/Carrusel4.webp";
import image5 from "../images/Carrusel5.webp";
import image6 from "../images/Carrusel6.webp";

const slides = [
  { title: "Gestor de Canales", image: image1 },
  { title: "Motor de Reservas", image: image2 },
  { title: "Estadísticas y Reportes", image: image3 },
  { title: "Gestión de Reservas", image: image4 },
  { title: "Pagos Integrados", image: image5 },
  { title: "Multi Propiedad", image: image6 },
];

export default function ImageCarouselConTitulos() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: 700,
        mx: "auto",
        borderRadius: 4,
        boxShadow: 6,
        bgcolor: "#fff",
      }}
    >
      <CardContent sx={{ textAlign: "center", pb: 1 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "'Red Hat Display', sans-serif",
            fontWeight: 600,
            color: "rgba(0, 0, 0, 0.6)",
            fontSize: {
              xs: "1.1rem",
              sm: "1.3rem",
              md: "1.5rem",
            },
          }}
        >
          {slides[index].title}
        </Typography>
      </CardContent>

      <Box
        component="img"
        src={slides[index].image}
        alt={slides[index].title}
        sx={{
          width: "100%",
          height: "auto",
          mb: 2,
          objectFit: "cover",
          borderBottomLeftRadius: 16,
          borderBottomRightRadius: 16,
          transition: "opacity 0.5s ease-in-out",
          display: "block",
        }}
      />
    </Card>
  );
}